export default __webpack_public_path__ + "static/l1-hero-img-3-9775dc463a2c5307bc065ed343aee234.png";